module.exports = __webpack_public_path__ + "img/tour-17.a31c5f02.png";